import { render, staticRenderFns } from "./ResourceChapterItem.vue?vue&type=template&id=5cb21cda&"
import script from "./ResourceChapterItem.vue?vue&type=script&lang=ts&"
export * from "./ResourceChapterItem.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceChapterItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports